import { type ValidationError } from '@adv-frontend/form-kit';
import { pluralize } from '../../../string';

export const MAX_LENGTH_ERROR_CODE = 'MAX_LENGTH_ERROR';

type MaxLengthErrorParams = {
    maxLength: number;
};

export type MaxLengthValidationError = ValidationError<typeof MAX_LENGTH_ERROR_CODE, MaxLengthErrorParams>;

export const MAX_LENGTH_ERROR_MESSAGE = ({ maxLength }: MaxLengthErrorParams) =>
    `Превышение максимальной длины в ${pluralize(maxLength, `%d символ`, `%d символа`, `%d символов`)}`;
